import React from 'react';
import { Instagram, Facebook, Twitter, Mail, Phone, MapPin } from 'lucide-react';
const instagramGrid = ['https://images.unsplash.com/photo-1555244162-803834f70033?auto=format&fit=crop&q=80&w=300', 'https://images.unsplash.com/photo-1528605248644-14dd04022da1?auto=format&fit=crop&q=80&w=300', 'https://images.unsplash.com/photo-1547592166-23ac45744acd?auto=format&fit=crop&q=80&w=300', 'https://images.unsplash.com/photo-1519225421980-715cb0215aed?auto=format&fit=crop&q=80&w=300', 'https://images.unsplash.com/photo-1604329760661-e71dc83f8f26?auto=format&fit=crop&q=80&w=300', 'https://images.unsplash.com/photo-1544025162-d76694265947?auto=format&fit=crop&q=80&w=300'];
export function Footer() {
  return <footer className="bg-brand-black text-white pt-24 pb-12 border-t border-white/10" data-id="element-40">
      <div className="max-w-7xl mx-auto px-6" data-id="element-41">
        <div className="grid lg:grid-cols-4 gap-16 mb-20" data-id="element-42">
          {/* Brand & Social */}
          <div className="col-span-1 lg:col-span-1" data-id="element-43">
            <img src="https://cdn.magicpatterns.com/uploads/qTzjp2dzSu8XKjmJQNf3Qh/Catering_Logo.png" alt="Logo" className="h-24 w-auto mb-8 object-contain" data-id="element-44" />
            <p className="text-gray-400 mb-8 leading-relaxed" data-id="element-45">
              Exceptional cuisine for every occasion. African woman-owned and
              operated, serving the DMV area with pride.
            </p>
            <div className="flex gap-4" data-id="element-46">
              <a href="#" className="w-10 h-10 rounded-full border border-white/10 flex items-center justify-center hover:bg-brand-gold hover:border-brand-gold transition-all" data-id="element-47">
                <Instagram size={18} data-id="element-48" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full border border-white/10 flex items-center justify-center hover:bg-brand-gold hover:border-brand-gold transition-all" data-id="element-49">
                <Facebook size={18} data-id="element-50" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full border border-white/10 flex items-center justify-center hover:bg-brand-gold hover:border-brand-gold transition-all" data-id="element-51">
                <Twitter size={18} data-id="element-52" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div data-id="element-53">
            <h4 className="text-brand-gold uppercase tracking-widest text-sm font-bold mb-8" data-id="element-54">
              Navigation
            </h4>
            <ul className="space-y-4 text-gray-400" data-id="element-55">
              <li data-id="element-56">
                <a href="#" className="hover:text-white transition-colors" data-id="element-57">
                  Home
                </a>
              </li>
              <li data-id="element-58">
                <a href="#services" className="hover:text-white transition-colors" data-id="element-59">
                  Event Services
                </a>
              </li>
              <li data-id="element-60">
                <a href="#menu" className="hover:text-white transition-colors" data-id="element-61">
                  Meal Prep
                </a>
              </li>
              <li data-id="element-62">
                <a href="#story" className="hover:text-white transition-colors" data-id="element-63">
                  Our Story
                </a>
              </li>
              <li data-id="element-64">
                <a href="#" className="hover:text-white transition-colors" data-id="element-65">
                  Request a Quote
                </a>
              </li>
            </ul>
          </div>

          {/* Contact & SEO */}
          <div data-id="element-66">
            <h4 className="text-brand-gold uppercase tracking-widest text-sm font-bold mb-8" data-id="element-67">
              Contact Us
            </h4>
            <ul className="space-y-6 text-gray-400" data-id="element-68">
              <li className="flex gap-4" data-id="element-69">
                <MapPin className="text-brand-gold shrink-0" size={20} data-id="element-70" />
                <span data-id="element-71">Serving DC, Maryland, and Northern Virginia (DMV)</span>
              </li>
              <li className="flex gap-4" data-id="element-72">
                <Phone className="text-brand-gold shrink-0" size={20} data-id="element-73" />
                <span data-id="element-74">(202) 555-0123</span>
              </li>
              <li className="flex gap-4" data-id="element-75">
                <Mail className="text-brand-gold shrink-0" size={20} data-id="element-76" />
                <span data-id="element-77">hello@versatilityeats.com</span>
              </li>
            </ul>
          </div>

          {/* Instagram Grid */}
          <div data-id="element-78">
            <h4 className="text-brand-gold uppercase tracking-widest text-sm font-bold mb-8" data-id="element-79">
              Follow Our Journey
            </h4>
            <div className="grid grid-cols-3 gap-2" data-id="element-80">
              {instagramGrid.map((img, i) => <div key={i} className="aspect-square overflow-hidden rounded-sm" data-id="element-81">
                  <img src={img} alt="Instagram" className="w-full h-full object-cover hover:scale-110 transition-transform duration-500" data-id="element-82" />
                </div>)}
            </div>
          </div>
        </div>

        <div className="pt-12 border-t border-white/5 flex flex-col md:flex-row justify-between items-center gap-6 text-sm text-gray-500" data-id="element-83">
          <p data-id="element-84">© 2024 Versatile LLC Cater 2 U. All rights reserved.</p>
          <div className="flex gap-8" data-id="element-85">
            <a href="#" className="hover:text-white transition-colors" data-id="element-86">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-87">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>;
}